import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

import TextInput from "@/components/atoms/Form/TextInput/TextInput";

export const StyledTextInput = styled(TextInput)(({ theme }) => ({
    [`& .MuiFormHelperText-root`]: {
        color: theme.palette.text.secondary,
    },
}));

export const BorderLinearProgress = styled(LinearProgress)(({ theme, value, disabled }) => ({
    height: 6,
    borderRadius: 3,
    marginBottom: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 3,
        backgroundColor: disabled ? theme.palette.action.disabledBackground : value === 100 ? "#49BC74" : "#FF4E50",
        transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
}));
